import "core-js-pure/web";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import AppWithAuth from "./AppWithAuth";
import * as serviceWorker from "./serviceWorker";
import store from "./store/configureStore";
import { Provider } from "react-redux";

// this import should enable import transpilation
import "react-imported-component/macro";

import "./async-imports";

ReactDOM.render(
  <Provider store={store}>
    <AppWithAuth />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
